import { forwardRef } from "react";
import type { IconProps } from "../shared";
import { Icon } from "../icon";
export const IconAlertCircle = forwardRef<HTMLElement, IconProps>(
    (props, ref) => (
        <Icon ref={ref} {...props}>
            <path
                fill="#111928"
                fillRule="evenodd"
                d="M12 4c4.416 0 8 3.584 8 8s-3.584 8-8 8-8-3.584-8-8 3.584-8 8-8m0 10.667a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666m-.889-1.778V7.556h1.778v5.333z"
                clipRule="evenodd"
            />
        </Icon>
    )
);
IconAlertCircle.displayName = "IconAlertCircle";
